export const projectList = {
    breadcrumb: {
        projectList: 'Project list',
    },
    card: {
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        by: 'by',
        projectAdmin: 'Project admin',
    },
    projectTable: {
        filterForm: {
            keyword: {
                label: 'Keyword',
                placeholder: 'Enter keyword',
            },
            category: {
                label: 'Category',
                placeholder: 'Select category',
            },
            createdBy: {
                label: 'Created by',
                placeholder: 'Select created by',
            },
            createdAt: {
                label: 'Created at',
                placeholder: {
                    start: 'Start date',
                    end: 'End date',
                },
                to: 'To',
            },
        },
        header: {
            projectName: 'Project name',
            category: 'Category',
            description: 'Description',
            place: 'Place',
            createdBy: 'Created by',
            action: 'Action',
        },
        action: {
            view: 'View',
        },
        tooltip: {
            collection: 'View project in collection',
            table: 'View project in table',
        },
    },
};
